// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IPublicV1CreateCpdDraftRequest {
  /** Метка продукта **/
  source: string;
  /** Id объявления **/
  offerId?: TPublicV1CreateCpdDraftRequest_OfferId;
  /** Адрес объекта **/
  address?: TPublicV1CreateCpdDraftRequest_Address;
  /** Телефон пользователя **/
  phone?: TPublicV1CreateCpdDraftRequest_Phone;
  /** Регион, в котором была создана заявка **/
  regionId?: TPublicV1CreateCpdDraftRequest_RegionId;
  /** Источник, откуда пользователь попал на ловушку **/
  cianSource?: TPublicV1CreateCpdDraftRequest_CianSource;
  /** Источник трафика **/
  utmSource?: TPublicV1CreateCpdDraftRequest_UtmSource;
  /** Тип трафика **/
  utmMedium?: TPublicV1CreateCpdDraftRequest_UtmMedium;
  /** Название рекламной кампании, из которой пришел пользователь **/
  utmCampaign?: TPublicV1CreateCpdDraftRequest_UtmCampaign;
  /** URL-адрес страницы, с которой пользователь перешел на сайт **/
  referrer?: TPublicV1CreateCpdDraftRequest_Referrer;
  /** Тип объекта недвижимости **/
  offerType?: TPublicV1CreateCpdDraftRequest_OfferType;
  /** Тип сделки **/
  dealType?: TPublicV1CreateCpdDraftRequest_DealType;
  /** Категория объявления **/
  category?: TPublicV1CreateCpdDraftRequest_Category;
  /** Принято ли пользовательское соглашение **/
  legalAgreementAccepted?: TPublicV1CreateCpdDraftRequest_LegalAgreementAccepted;
  /** Реферальный код **/
  referralCode?: TPublicV1CreateCpdDraftRequest_ReferralCode;
}

export type TPublicV1CreateCpdDraftRequest_OfferId = null | number;

export type TPublicV1CreateCpdDraftRequest_Address = null | string;

export type TPublicV1CreateCpdDraftRequest_Phone = null | string;

export type TPublicV1CreateCpdDraftRequest_RegionId = null | number;

export type TPublicV1CreateCpdDraftRequest_CianSource = null | string;

export type TPublicV1CreateCpdDraftRequest_UtmSource = null | string;

export type TPublicV1CreateCpdDraftRequest_UtmMedium = null | string;

export type TPublicV1CreateCpdDraftRequest_UtmCampaign = null | string;

export type TPublicV1CreateCpdDraftRequest_Referrer = null | string;

export type TPublicV1CreateCpdDraftRequest_OfferType = null | EOfferType;

export enum EOfferType {
  /** Квартира **/
  'Flat' = 'flat',
  /** Загородная недвижимость **/
  'Suburban' = 'suburban',
  /** Коммерческая недвижимость **/
  'Commercial' = 'commercial',
  /** Новостройка **/
  'Newobject' = 'newobject',
}
export type TPublicV1CreateCpdDraftRequest_DealType = null | EDealType;

export enum EDealType {
  /** Покупка **/
  'Buy' = 'buy',
  /** Продажа **/
  'Sale' = 'sale',
  /** Сдача **/
  'Rent' = 'rent',
  /** Аренда **/
  'Tenant' = 'tenant',
  /** Альтернативная сделка **/
  'SellToBuy' = 'sellToBuy',
  /** Клиент не определился **/
  'Unknown' = 'unknown',
}
export type TPublicV1CreateCpdDraftRequest_Category = null | ECategory;

export enum ECategory {
  /** Продажа квартиры **/
  'FlatSale' = 'flatSale',
  /** Продажа комнаты **/
  'RoomSale' = 'roomSale',
  /** Продажа квартиры в новостройке **/
  'NewBuildingFlatSale' = 'newBuildingFlatSale',
  /** Продажа доли в квартире **/
  'FlatShareSale' = 'flatShareSale',
  /** Продажа дома/дачи **/
  'HouseSale' = 'houseSale',
  /** Продажа коттеджа **/
  'CottageSale' = 'cottageSale',
  /** Продажа таунхауса **/
  'TownhouseSale' = 'townhouseSale',
  /** Продажа части дома **/
  'HouseShareSale' = 'houseShareSale',
  /** Продажа участка **/
  'LandSale' = 'landSale',
  /** Аренда квартиры **/
  'FlatRent' = 'flatRent',
  /** Аренда комнаты **/
  'RoomRent' = 'roomRent',
  /** Аренда койко-места **/
  'BedRent' = 'bedRent',
  /** Аренда дома/дачи **/
  'HouseRent' = 'houseRent',
  /** Аренда коттеджа **/
  'CottageRent' = 'cottageRent',
  /** Аренда таунхауса **/
  'TownhouseRent' = 'townhouseRent',
  /** Аренда части дома **/
  'HouseShareRent' = 'houseShareRent',
  /** Посуточная аренда квартиры **/
  'DailyFlatRent' = 'dailyFlatRent',
  /** Посуточная аренда комнаты **/
  'DailyRoomRent' = 'dailyRoomRent',
  /** Посуточная аренда койко-места **/
  'DailyBedRent' = 'dailyBedRent',
  /** Посуточная аренда дома, дачи, коттеджа **/
  'DailyHouseRent' = 'dailyHouseRent',
  /** Продажа офиса **/
  'OfficeSale' = 'officeSale',
  /** Продажа склада **/
  'WarehouseSale' = 'warehouseSale',
  /** Продажа торговой площади **/
  'ShoppingAreaSale' = 'shoppingAreaSale',
  /** Продажа производство **/
  'IndustrySale' = 'industrySale',
  /** Продажа здания **/
  'BuildingSale' = 'buildingSale',
  /** Продажа помещения свободного назначения **/
  'FreeAppointmentObjectSale' = 'freeAppointmentObjectSale',
  /** Продажа готового бизнеса **/
  'BusinessSale' = 'businessSale',
  /** Продажа коммерческой земли **/
  'CommercialLandSale' = 'commercialLandSale',
  /** Продажа гаража **/
  'GarageSale' = 'garageSale',
  /** Аренда офиса **/
  'OfficeRent' = 'officeRent',
  /** Аренда склада **/
  'WarehouseRent' = 'warehouseRent',
  /** Аренда торговой площади **/
  'ShoppingAreaRent' = 'shoppingAreaRent',
  /** Аренда производства **/
  'IndustryRent' = 'industryRent',
  /** Аренда здания **/
  'BuildingRent' = 'buildingRent',
  /** Аренда помещения свободного назначения **/
  'FreeAppointmentObjectRent' = 'freeAppointmentObjectRent',
  /** Аренда готового бизнеса **/
  'BusinessRent' = 'businessRent',
  /** Аренда коммерческой земли **/
  'CommercialLandRent' = 'commercialLandRent',
  /** Аренда гаража **/
  'GarageRent' = 'garageRent',
  /** Продажа общепита **/
  'PublicCateringSale' = 'publicCateringSale',
  /** Продажа автосервиса **/
  'CarServiceSale' = 'carServiceSale',
  /** Продажа помещения под бытовые услуги **/
  'DomesticServicesSale' = 'domesticServicesSale',
  /** Аренда общепита **/
  'PublicCateringRent' = 'publicCateringRent',
  /** Аренда автосервис **/
  'CarServiceRent' = 'carServiceRent',
  /** Аренда помещения под бытовые услуги **/
  'DomesticServicesRent' = 'domesticServicesRent',
}
export type TPublicV1CreateCpdDraftRequest_LegalAgreementAccepted = null | boolean;

export type TPublicV1CreateCpdDraftRequest_ReferralCode = null | string;
